import {
  CLOSE_ACCOUNT_CMS_LOADED,
  CLOSE_ACCOUNT_CMS_LOADING,
  CLOSE_ACCOUNT_REASONS_LOADED,
  CLOSE_ACCOUNT_REASONS_LOADING,
  CLOSE_ACCOUNT_SET_STEP
} from '../../../screens/close-account/utils/constants';

const initialState = {
  cmsData: null,
  isLoading: true,
  step: 'intro',
  closureReasons: [],
  isReasonsLoading: true
};

const closeAccountReducer = (state = initialState, action) => {
  switch (action.type) {
    case CLOSE_ACCOUNT_CMS_LOADING:
      return { ...state, isLoading: true };
    case CLOSE_ACCOUNT_CMS_LOADED:
      return { ...state, cmsData: action.payload, isLoading: false };
    case CLOSE_ACCOUNT_SET_STEP:
      return { ...state, step: action.payload };
    case CLOSE_ACCOUNT_REASONS_LOADING:
      return { ...state, isReasonsLoading: true };
    case CLOSE_ACCOUNT_REASONS_LOADED:
      return { ...state, closureReasons: action.payload, isReasonsLoading: false };
    default:
      return state;
  }
};

export default closeAccountReducer;
